/**
 * Unions Catalog Mapper
 */

import type { LC_UnionItem, Union } from './unions.types.ts';

/**
 * Map LC_UnionItem to Union
 */
export function mapUnionOutToModel(item: LC_UnionItem): Union {
  return {
    id: item.unionId,
    name: item.union,
  };
}
